<ngx-datatable
  class="bootstrap h-100"
  #tableDataComponent
  [rows]="data.data"
  [columns]="sortedColumns"
  [columnMode]="ColumnMode.force"
  [rowHeight]="(environment.env_name === 'local' || environment.env_name === 'local-stage' )? 'auto' : 45"
  [reorderable]="false"
  (page)="goToPage($event.offset + 1)"
  [rowIdentity]="rowIdentity"
  trackByProp="id"
  [externalSorting]="true"
  [loadingIndicator]="isLoading"
  (sort)="sort($event.sorts)"
  [sorts]="sorts"
  [sortType]="keyPressedShift ? SortType.multi : SortType.single"
  [externalPaging]="true"
  [count]="data.meta.total"
  [limit]="data.meta.per_page"
  [ghostLoadingIndicator]="false"
  [offset]="data.meta.current_page - 1"
  [footerHeight]="0"
  [headerHeight]="headerHeight"
  [scrollbarVDynamic]="true"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [virtualization]="false"
  [messages]="{
    emptyMessage: 'table.no_results' | translate,
    totalMessage: 'table.total' | translate,
    selectedMessage: 'table.selected' | translate
  }"
  [class.fixed-body-height]="isSubtable"
>

  <div empty-content class="no-results text-center fs-3 p-5 bg-light text-black-50">
    {{ 'table.no_results' | translate }}
  </div>

  <div loading-indicator style="text-align: center;background: none !important;">
    <i class="fa fa-spin fa-circle-notch fa-2x my-5"></i>
  </div>

  <ngx-datatable-column
    [sortable]="false"
    [canAutoResize]="false"
    [width]="30"
    [draggable]="false"
    [resizeable]="false"
    *ngIf="showEditLink && userSessionService.hasAnyPermission([$any(tableDisplayConfig.tableConfig?.permissions?.read), $any(tableDisplayConfig.tableConfig?.permissions?.update)])"
  >
    <ng-template
      ngx-datatable-header-template
    ></ng-template>


    <ng-template
      ngx-datatable-cell-template
      let-row="row"
    >


      <ng-container *ngIf="routerLinkValue; else defaultLink">
        <a *ngIf="row[routerLinkValue]; else errorLink" [routerLink]="(routerLinkPrefix + row[routerLinkValue] + routerLinkSuffix)"
           class="text-decoration-none text-body fs-6">
          <i class="fa fa-edit"></i>
        </a>
        <ng-template #errorLink>
          <a (click)="showRouterError($event)" href="#" class="text-decoration-none text-body fs-6">
            <i class="fa fa-edit"></i>
          </a>
        </ng-template>
      </ng-container>
      <ng-template #defaultLink>
        <a *ngIf="showEditLink" routerLink="{{ (routerLinkPrefix + row.id + routerLinkSuffix) }}"
           class="text-decoration-none text-body fs-6">
          <i class="fa fa-edit"></i>
        </a>
      </ng-template>
    </ng-template>

  </ngx-datatable-column>


  <ngx-datatable-column
    [width]="additionalButtonWidth"
    [sortable]="false"
    [cellClass]="'text-truncate position-relative'"
    [canAutoResize]="false"
    [draggable]="false"
    [resizeable]="false"
    *ngIf="additionalButton?.elementRef?.nativeElement"
  >
    <ng-template
      ngx-datatable-header-template
    >{{ additionalButtonHeaderText | translate }}
    </ng-template>

    <ng-template
      ngx-datatable-cell-template
      let-row="row"

    >
      <ng-container *ngTemplateOutlet="additionalButton; context: {$implicit: row}"></ng-container>

    </ng-template>


  </ngx-datatable-column>


  <ng-container *ngFor="let col of  sortedColumns;let first = first">

    <ngx-datatable-column
      *ngIf="(col | shouldShowColumn:tableDisplayConfig.hidden_columns) && functionColumnTypeList.includes(col.type)"
      [cellClass]="'text-truncate position-relative'"
      [checkboxable]="false"
      [draggable]="false"
      [headerCheckboxable]="false"
      [sortable]="false"
      [canAutoResize]="false"
      [width]="100"
      [resizeable]="false"
      [name]="(('tables.' + tableDisplayConfig.tableConfig!.id + '.' + col.name) | translate)"
      [prop]="col.name"
    >
      <ng-template
        ngx-datatable-header-template
      ></ng-template>

      <ng-template let-row="row" ngx-datatable-cell-template>
        <ng-container *ngIf="row[col.name]  === null"></ng-container>

        <!-- Booking Question answer options is laut backend keine collection, daher der array check-->
        <ng-container *ngIf="row[col.name]  !== null && isArray(row[col.name]) && row[col.name]?.length > 0"
                      [ngTemplateOutlet]="collectionTemplate"
                      [ngTemplateOutletContext]="{col: col, value: row[col.name], row}"></ng-container>

        <ng-container *ngIf="row[col.name]  !== null && !isArray(row[col.name])"
                      [ngTemplateOutlet]="singleTemplate"
                      [ngTemplateOutletContext]="{col: col, value: row[col.name], row}"></ng-container>


      </ng-template>
    </ngx-datatable-column>

    <!-- Hide *_id columns => we only show the relation columns -->
    <ngx-datatable-column

      *ngIf="(col|shouldShowColumn:tableDisplayConfig.hidden_columns) && !functionColumnTypeList.includes(col.type)"
      [cellClass]="'text-truncate position-relative'"
      [checkboxable]="false"
      [cellTemplate]="cellTemplate ?? defaultCellTemplate"
      [draggable]="false"
      [headerCheckboxable]="false"
      [resizeable]="true"
      [sortable]="col.sortable"

      [minWidth]="100"
      [width]="tableDisplayConfig.column_widths[col.name]"

      [canAutoResize]="true"
      [name]="(('tables.' + tableDisplayConfig.tableConfig!.id + '.' + col.name) |translate)"
      [prop]="col.name"
    >
      <ng-template let-row="row" #defaultCellTemplate>
        <ng-container *ngIf="row[col.name]  === null"></ng-container>
        <ng-container
          *ngIf="!row.hasOwnProperty(col.name) && !['copy_button', 'inline_download_button', 'custom_function', 'blocked_resources', 'inline_delete_button'].includes(col.name)">
          <div class="alert alert-warning p-1 ">Missing property <code>{{ col.name }}</code></div>
        </ng-container>

        <!-- Booking Question answer options is laut backend keine collection, daher der array check-->
        <ng-container *ngIf="row[col.name]  !== null && isArray(row[col.name]) && row[col.name]?.length > 0"
                      [ngTemplateOutlet]="collectionTemplate"
                      [ngTemplateOutletContext]="{col: col, value: row[col.name], row}"></ng-container>

        <ng-container *ngIf="row[col.name]  !== null && !isArray(row[col.name])"
                      [ngTemplateOutlet]="singleTemplate"
                      [ngTemplateOutletContext]="{col: col, value: row[col.name], row}"></ng-container>


      </ng-template>
    </ngx-datatable-column>
  </ng-container>
</ngx-datatable>

<ng-template #collectionTemplate let-value="value" let-col="col" let-row="row">

  <ng-container *ngFor="let c of row[col.name];let last = last">
    <ng-container [ngTemplateOutlet]="singleTemplate"
                  [ngTemplateOutletContext]="{ value: c, col: col, row: row }"
    ></ng-container><ng-container *ngIf="!last">, </ng-container>
  </ng-container>
</ng-template>

<ng-template #singleTemplate let-value="value" let-col="col" let-row="row">
  <ng-container [ngSwitch]="col.type">
    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INT">
      {{ value  | number }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.FILE_SIZE">
      {{ value  | filesize }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.STRING">
      <span class="font-monospace small cursor-copy" *ngIf="col.name === 'id'" #copy ngxClipboard [cbContent]="value"
            (cbOnSuccess)="copied(value)">
        {{ value }}
      </span>
      <ng-container *ngIf="col.name !== 'id'">{{ value }}</ng-container>

    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.FLOAT">
      {{ value  | number }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA">
      <ng-container *ngIf="locale === 'de'">{{ value ['de'] }}</ng-container>
      <ng-container *ngIf="locale !== 'de'">{{ value ['en'] }}</ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.BOOL">
      <i class="fa fa-check" *ngIf="value  === true"></i>
      <i class="fa fa-ban" *ngIf="value  === false"></i>
      <i class="fa fa-question" *ngIf="value  === null"></i>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.ARRAY">
      <ng-container *ngIf="isArray(value)">
        {{ value?.join(',') }}
      </ng-container>

      <ng-container *ngIf="!isArray(value)">
        {{ value | json }}
      </ng-container>


    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.CARBON_IMMUTABLE">
      @if (col.name === 'sent_at' || col.name === 'occurred_at') {
        <span class="text-nowrap">
            {{ value | dfnsParseIso | formatInTimeZone: dfnsLocale: 'medium' }}
        </span>
      } @else {
        <span class="text-nowrap">
            {{ value | dfnsParseIso | formatInTimeZone: dfnsLocale: 'mediumDate' }}
        </span>
      }
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.DATE">
      <span class="text-nowrap">
          {{ value | dfnsParseIso | formatInTimeZone: dfnsLocale: 'mediumDate' }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.TIME">
      <span class="text-nowrap">
          {{ value | dfnsParseIso | formatInTimeZone: dfnsLocale: 'shortTime' }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE">
      {{ 'enums.modelStateEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_LANGUAGE_ENUM">
      {{ 'enums.patientLanguageEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_STATE_ENUM">
      {{ 'enums.patientStateEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.EMAIL_TYPE_ENUM">
      {{ 'enums.emailTypeEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.EMAIL_RESOURCE">
      {{ value.title }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_ORIGIN_ENUM">
      {{ 'enums.patientOriginEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_AUTHENTICATION_AUDIT_TYPE_ENUM">
      {{ 'enums.patientAuthenticationAuditTypeEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PASSWORD_RESET_ORIGIN_ENUM">
      {{ 'enums.passwordResetOriginEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.DIAGNOSIS_RESOURCE">{{ ' ' + value.title.de }}</ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.RELATION_TITLE_ATTRIBUTE_DATA">
      {{ value?.title }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.FK_DIAGNOSIS">
      {{ value.title.de }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_GENDER_ENUM">
      {{ 'enums.patientGenderEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.REDUCED_USER_RESOURCE">
      {{ value.name }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_RESOURCE">
      {{ value.first_name + ' ' + value.last_name }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.COMPUTED_BACKOFFICE_USER">
      <span class="text-white px-2 rounded h-100" [ngStyle]="{'background-color': value.color}">{{ value.name }}</span>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.COMPUTED_DOCTOR">
      {{ value.name }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.ROLE_RESOURCE">{{ 'enums.roleEnum.' + value.key  | translate }}</ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INQUIRY_STATE_ENUM">
      {{ 'enums.inquiryStateEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.QM_PROCESS_CATEGORY_ENUM">
      <span class="px-2 rounded h-100" [ngStyle]="getProcessCategoryStyle(value)">{{ 'enums.processCategoryEnum.' + value  | translate }}</span>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.QM_PROCESS_PRIORITY_ENUM">
      {{ 'enums.processPriorityEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.QM_PROCESS_COMPLEXITY_ENUM">
      {{ 'enums.processComplexityEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.QM_PROCESS_ROLE_ENUM">
      {{ 'enums.processRoleEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.PATIENT_SOURCE_ENUM">
      {{ 'enums.patientSourceEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.TIME_TRACKING_ENTRY_TYPE_ENUM">
      {{ 'enums.timeTrackingEntryTypeEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.QM_PROCESS_RESOURCE">
      {{ value.title }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.TIME_TRACKING_EMPLOYEE_RESOURCE">
      {{ value?.user?.name ?? '' }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM">
      {{ 'enums.timeTrackingAbsenceRequestStateEnum.' + value  | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.GERMAN_STATE_ENUM">
      {{ 'enums.germanStateEnum.' + value  | translate }}</ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.WEEK_DAY_ENUM">
      {{ 'enums.weekDayEnum.' + value  | translate }}</ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INL_FUNC_INLINE_EDIT_AND_DELETE_BUTTON">
      <div class="btn-group btn-group-sm position-absolute top-50 translate-y-middle">
        <button *ngIf="functionList?.edit !== undefined" type="button" (click)="functionList?.edit(row)"
                class="btn btn-outline-primary btn-sm">
          <i class="fa fa-edit"></i>
        </button>
        <button *ngIf="functionList?.delete !== undefined" type="button" (click)="functionList?.delete(row)"
                class="btn btn-danger btn-sm">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INL_FUNC_INLINE_DOWNLOAD_AND_DELETE_BUTTON">
      <div class="btn-group btn-group-sm position-absolute top-50 translate-y-middle">
        <button *ngIf="functionList?.privateAttachmentDownload !== undefined" type="button" (click)="functionList?.privateAttachmentDownload(row)"
                class="btn btn-outline-primary btn-sm">
          <i class="fa-solid fa-download"></i>
        </button>
        <button *ngIf="functionList?.delete !== undefined" type="button" (click)="functionList?.delete(row)"
                class="btn btn-danger btn-sm">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INL_FUNC_INLINE_DOWNLOAD_BUTTON">
      <div class="btn-group btn-group-sm position-absolute top-50 translate-y-middle">
        <button *ngIf="functionList?.privateAttachmentDownload !== undefined" type="button" (click)="functionList?.privateAttachmentDownload(row)"
                class="btn btn-outline-primary btn-sm">
          <i class="fa-solid fa-download"></i>
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INL_FUNC_INLINE_DELETE_BUTTON">
      <button *ngIf="functionList?.delete !== undefined" type="button" (click)="functionList?.delete(row)"
              class="btn btn-danger btn-sm position-absolute top-50 translate-y-middle">
        <i class="fa fa-trash"></i>
      </button>
    </ng-container>

    <ng-container *ngSwitchCase="TableConfigColumnTypeEnum.INL_FUNC_CUSTOM_FUNCTION">
      <a *ngIf="
          functionList?.custom !== undefined &&
          !!functionList?.custom(row) &&
          $any(functionList?.custom(row))['type'] === CUSTOM_TABLE_FUNCTION_TYPES.LINK
        "
         type="button" (click)="functionList?.custom(row)"
         class="link"
         [routerLink]="$any(functionList?.custom(row))['payload']"
         target="_blank"
      >
        {{ $any(functionList?.custom(row))['value'] }}
      </a>

      <button *ngIf="
          functionList?.custom !== undefined &&
          !!functionList?.custom(row) &&
          $any(functionList?.custom(row))['type'] === CUSTOM_TABLE_FUNCTION_TYPES.BUTTON
        "
         type="button" (click)="functionList?.custom(row)?.action()"
         class="btn btn-sm"
      >
        <i class="fa" [ngClass]="functionList?.custom(row)?.iconClass"></i>
        {{ $any(functionList?.custom(row))['value'] }}
      </button>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="alert alert-danger">
        col.type not implemented <br>
        <code>{{ col.type }}</code> <br>
        <code>{{ col.name }}</code>
      </div>
    </ng-container>

  </ng-container>


</ng-template>
